import "@tento-ui/components/icon-button";
import "@tento-ui/components/list/list-cell-layout";

import { html, LonaWebComponent } from "@tento-ui/component";
import { component } from "@tento-ui/component-decorators";
import { css, Style } from "@tento-ui/component-styles";
import { IconButton } from "@tento-ui/components/icon-button";
import { GESTURE_MANAGER } from "@tento-ui/gesture-manager";
import { LonaIcons, PencilIcon } from "@tento-ui/ui/icons";
import { Typography } from "@tento-ui/ui/typography";
import { SchedulingLinks } from "@tento-lona";

@component({
  name: "lona-scheduling-link-cell",
})
export class SchedulingLinkCell extends LonaWebComponent {
  private $root: HTMLElement = this.$("root");
  private $editBtn: IconButton = this.hydrate("edit-btn");

  static makeWith(props: SchedulingLinkCell.Props): SchedulingLinkCell {
    const $e = SchedulingLinkCell.make();
    $e.bind(props);
    return $e;
  }

  bind(props: SchedulingLinkCell.Props) {
    GESTURE_MANAGER.unregister(this);

    this.$("title").textContent =
      props.link.label ?? props.link.attributes.slug;
    this.$("link").textContent = props.link.bookingUrl();
    this.$("duration").textContent =
      `${props.link.attributes.durationMinutes}m`;
    const isActive = props.link.attributes.isActive !== false;
    this.$("status").textContent = isActive ? "" : "Paused";
    this.$("status-separator").style.display = isActive ? "none" : "";

    GESTURE_MANAGER.addPointerEvent(this.$root, {
      onClick: () => props.onSelect(),
    });

    this.$editBtn.bind({
      content: LonaIcons.make(PencilIcon, { sizePx: 14 }),
      sizePx: 24,
    });
    GESTURE_MANAGER.addPointerEvent(this.$editBtn, {
      onClick: () => props.onEdit?.(),
    });
  }

  static override $styles: Style.Compat[] = [
    Typography.$noWrap,
    css`
      #root {
        --list-cell-padding: 10px 8px;
        cursor: pointer;
      }

      #info {
        min-width: 0;
      }

      #title {
        --margin-bottom: 8px;
        color: var(--text-pri);
      }

      #subtitle {
        color: var(--text-ter);
        font-weight: 300;
      }

      #status {
        color: var(--orange);
        font-weight: 500;
      }

      #edit-btn {
        flex-shrink: 0;
        opacity: 0;
        transition: opacity 0.3s ease;
      }

      #root:hover #edit-btn {
        opacity: 1;
      }
    `,
  ];
  static override $html: Option<HTMLTemplateElement> = html`
    <std-list-cell-layout id="root">
      <std-col id="info" slot="content">
        <p id="title" class="small"></p>
        <p id="subtitle" class="small no-wrap">
          <span id="status"></span>
          <span id="status-separator">&middot;</span>
          <span id="duration">30m</span>
          <span>&middot;</span>
          <span id="link"></span>
        </p>
      </std-col>
      <std-icon-button id="edit-btn" slot="accessory"></std-icon-button>
    </std-list-cell-layout>
  `;
}

export namespace SchedulingLinkCell {
  export interface Props {
    link: SchedulingLinks.Row;
    onSelect: () => void;
    onEdit?: () => void;
  }
}
